<template>
  <div class="pill-container">
    <div class="pill">
      <div class="loader"></div>
    </div>
  </div>
</template>

<style scoped>
.pill-container {
  height: 110px;
  width: 100%;
  display: grid;
  place-items: center;
}

.pill {
  position: relative;
  width: 90px;
  height: 90px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 0 2px #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 35px;
  aspect-ratio: 1;
  --c: linear-gradient(rgba(48, 76, 140, 0.84) 0 0);
  --r1: radial-gradient(farthest-side at bottom, #114072 93%, #0000);
  --r2: radial-gradient(farthest-side at top, #114072 93%, #0000);
  background: var(--c), var(--r1), var(--r2), var(--c), var(--r1), var(--r2),
    var(--c), var(--r1), var(--r2);
  background-repeat: no-repeat;
  animation: l1 1s infinite alternate;
}
@keyframes l1 {
  0%,
  10% {
    background-size: 8px 0, 8px 4px, 8px 4px;
    background-position: 0 50%, 0 calc(50% - 2px), 0 calc(50% + 2px), 50% 50%,
      50% calc(50% - 2px), 50% calc(50% + 2px), 100% 50%, 100% calc(50% - 2px),
      100% calc(50% + 2px);
  }
  90%,
  100% {
    background-size: 8px 100%, 8px 4px, 8px 4px;
    background-position: 0 50%, 0 -2px, 0 calc(100% + 2px), 50% 50%, 50% -2px,
      50% calc(100% + 2px), 100% 50%, 100% -2px, 100% calc(100% + 2px);
  }
}
</style>
